/* libs/oyan-ui/src/lib/features/sites/components/site-configurations/site-configurations.component.scss */
/*# sourceMappingURL=site-configurations.component.css.map */
